<div class="flex justify-end">
  <button nz-button nzType="primary" (click)="openAddNew()" nzSize="large">
    <nz-icon nzType="plus"/>
    Create
  </button>
</div>
<nz-divider nzText="Organizations"></nz-divider>

<nz-list nzGrid>
  <nz-list-header>
    <nz-input-group nzSearch nzSize="large" [nzAddOnAfter]="suffixButton">
      <input type="text" nz-input placeholder="input search text" (ngModelChange)="filterResults()"
             [(ngModel)]="searchTest"/>
    </nz-input-group>
    <ng-template #suffixButton>
      <button nz-button nzType="primary" nzSize="large" nzSearch (click)="filterResults()">Search</button>
    </ng-template>
  </nz-list-header>
  <div nz-row [nzGutter]="16">
    @for (item of organizations; track item) {
      <div nz-col [nzXXl]="8" [nzXl]="4" [nzLg]="6" [nzMd]="6" [nzSm]="12" [nzXs]="24">
        <nz-list-item>
          <nz-card [nzTitle]="item.name" style="background-color: #24172b" nzHoverable (click)="openOrganization(item)">
            <nz-descriptions [nzColumn]="1" [nzSize]="'small'">
              <nz-descriptions-item nzTitle="Email">{{ item.email }}</nz-descriptions-item>
              <nz-descriptions-item nzTitle="Phone">{{ item.phone }}</nz-descriptions-item>
              <nz-descriptions-item nzTitle="Adress">{{ item.address }}</nz-descriptions-item>
              <nz-descriptions-item nzTitle="ID">{{ item.id }}</nz-descriptions-item>
            </nz-descriptions>
          </nz-card>
        </nz-list-item>
      </div>
    }
    @if (organizations.length === 0) {
      <nz-list-empty nzNoResult="No Data"/>
    }
  </div>
</nz-list>
